import { CHANGE_PASSWORD_ERROR, CHANGE_PASSWORD_ERROR_CLEAR } from "store/actionTypes";

const initialState = {
    message: null,
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_PASSWORD_ERROR:
            state = {
                ...state,
                message: action.message,
            };
            break;
        case CHANGE_PASSWORD_ERROR_CLEAR:
            state = {
                ...state,
                message: null,
            };
            break;
        default:
            break;
    }

    return state;
};
